import React, { useState } from "react";
import Nav from "../../components/Nav/Nav";
import { Helmet } from "react-helmet-async";
import "./Stranger.css";

const siteUrl = "https://www.dore-avocat.fr";

const accordionItems = [
  {
    title: "Demandes de titres de séjour",
    content:
      "Le cabinet vous accompagne dans la préparation et le dépôt de vos demandes de titre de séjour : première demande, renouvellement ou changement de statut. Il vous conseille sur le fondement le plus adapté à votre situation et vous assiste dans vos démarches auprès de la préfecture.",
  },
  {
    title: "Recours en matière de séjour et d'éloignement",
    content:
      "Le cabinet assure votre défense contre les décisions prises par l'administration : refus de titre de séjour, obligation de quitter le territoire français (OQTF), interdiction de retour sur le territoire français (IRTF), assignation à résidence ou décision de transfert Dublin. Il intervient également lorsque l'administration ne répond pas à une demande ou en cas de difficultés dans l'instruction de votre dossier.",
  },
  {
    title: "Visas",
    content:
      "Le cabinet vous accompagne dans vos demandes de visa et vous conseille dans la constitution de votre dossier. En cas de refus, il assure également les recours administratifs et contentieux permettant de contester la décision.",
  },
  {
    title: "Regroupement familial et réunification familiale",
    content:
      "Le cabinet vous accompagne dans les procédures permettant de faire venir votre famille en France, notamment au titre du regroupement familial ou de la réunification familiale. Il intervient à toutes les étapes de la procédure et assure également votre défense en cas de refus ou de difficultés rencontrées auprès de l'administration.",
  },
];

function Stranger(props) {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <div>
      <Helmet>
        <title>Droit des étrangers - Maître Camille Doré, avocate à Lille</title>
        <meta name="description" content="Le cabinet de Maître Camille Doré vous accompagne en droit des étrangers à Lille et Paris : titres de séjour, regroupement familial, nationalité française, recours contre OQTF." />
        <link rel="canonical" href={`${siteUrl}/étranger`} />
        <meta property="og:title" content="Droit des étrangers - Maître Camille Doré, avocate à Lille" />
        <meta property="og:description" content="Le cabinet de Maître Camille Doré vous accompagne en droit des étrangers à Lille et Paris : titres de séjour, regroupement familial, nationalité française, recours contre OQTF." />
        <meta property="og:url" content={`${siteUrl}/étranger`} />
        <meta property="og:image" content={`${siteUrl}/images/stranger_compress.png`} />
      </Helmet>
      <Nav />
      <div className="stranger-hero">
        <h1>Droit des étrangers</h1>
      </div>
      <div className="stranger-intro">
        <div className="stranger-intro-photo">
          <img src="/images/stager-image_compress.jpg" alt="Droit des étrangers - passeport" />
        </div>
        <p>
          Le cabinet intervient en droit des étrangers pour vous assister dans vos démarches administratives et assurer votre défense en cas de contentieux.
        </p>
      </div>
      <div className="stranger-accordion">
        {accordionItems.map((item, i) => (
          <div className="acc-item" key={i}>
            <div className="acc-header" onClick={() => toggle(i)}>
              <h3>{item.title}</h3>
              <span className={`acc-chev${openIndex === i ? " open" : ""}`}>▲</span>
            </div>
            {openIndex === i && (
              <div className="acc-body">
                <p>{item.content}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Stranger;
